import script from "./RichTranslation.vue?vue&type=script&lang=ts"
export * from "./RichTranslation.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__